<template>
    <AuthPageInner title="Login">
        <LoginForm ref="form" @success="onSuccess"/>
    </AuthPageInner>
</template>

<script>

import axios from "axios";
import LoginForm from "@/Components/Auth/LoginForm.vue";
import AuthPageInner from "@/Components/Layout/AuthPageInner";

export default {

    name: "LoginPage",

    components: {
        AuthPageInner,
        LoginForm
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.form.focus();
        });
    },

    methods: {
        async onSuccess() {

            await this.$store.dispatch('fetchUser');

            let route = '/';

            if (this.$store.state.intended) {
                route = this.$store.state.intended;
                this.$store.commit('SET_INTENDED', null);
            }


            await this.$router.push(route);
        }
    },

    async beforeRouteEnter(to, from, next) {
        await axios.head(route('login'))
        next()
    },
}
</script>
